import CookieConsent from 'react-cookie-consent'
import { cookiesNotice } from './constant/Constant'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { usePolicyCore } from './util/policyCore'

const CookiesNotify = () => {
    const classes = useStyles()
    const { onPolicyLinkClicked, policyLinkCssClass } = usePolicyCore()
    return (
        <CookieConsent
            location="bottom"
            cookieName="dtt-cookies-consent"
            buttonText={cookiesNotice.acceptButton}
            containerClasses={classes.containerWrapper}
            buttonWrapperClasses={classes.buttonWrapper}
            buttonStyle={{
                backgroundColor: '#2780F9',
                color: 'white',
                borderRadius: '5px',
                fontFamily: 'Prompt_Light, sans-serif',
                padding: '8px 32px',
                margin: '16px 8px',
                fontSize: '14px',
            }}
            style={{
                backgroundColor: '#2B373B',
                color: '#fff',
                justifyContent: 'center',
                zIndex: 1500,
            }}
        >
            <>
                {cookiesNotice.content}{' '}
                <span onClick={onPolicyLinkClicked} className={policyLinkCssClass.policyLink}>
                    {cookiesNotice.txtHyperlink}
                </span>
            </>
        </CookieConsent>
    )
}

export default CookiesNotify

const useStyles = makeStyles((theme: Theme) => ({
    containerWrapper: {
        alignItems: 'center !important' as 'center',
        [theme.breakpoints.down('md')]: {
            display: 'block !important',
        },
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            paddingBottom: 16,
        },
    },
}))
